export const ENV = 'production';
export const BASE_URL = 'https://basecamp.prod.ropeup.fr';
export const FRONT_URL = 'https://widget.prod.ropeup.fr/';
export const IMG_BASE_URL = 'https://basecamp.prod.ropeup.fr/';
